module.exports = __webpack_public_path__ + "img/jo.17617e58.svg";